import { TranslateService } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';

export interface MenuElementInterface extends MenuItem {
  stringId: string;
  label: string;
  routerLink: string;
  id: string; // This id is mandatory for the automatic testing
}

/**
 * Computes the translation of each label of tabItems using the provided translate service
 * @param translate
 * @param tabItems
 * @returns a new tabItems with the translated labels
 */
export function computeTranslation(
  translate: TranslateService,
  tabItems: MenuElementInterface[]
): MenuElementInterface[] {
  const newTabItems: MenuElementInterface[] = [];
  tabItems.forEach((tab) => {
    tab.label = translate.instant(tab.stringId); // Computes the translation
    newTabItems.push(Object.assign({}, tab)); // Copy into new array
  });
  return newTabItems; // Need to provide a new array to trigger the update of the html element
}
